import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { error as _error } from "@instructure/console";

var _dec, _dec2, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
// TODO: remove delimeter comment description once the deprecated values are removed
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { View } from '@instructure/ui-view';
import { themeable, ThemeablePropTypes } from '@instructure/ui-themeable';
import { testable } from '@instructure/ui-testable';
import { passthroughProps, deprecated } from '@instructure/ui-react-utils';
var styles = {
  componentId: 'jpyTq',
  template: function template(theme) {
    return "\n\n.jpyTq_bGBk{color:".concat(theme.color || 'inherit', ";font-family:").concat(theme.fontFamily || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";line-height:").concat(theme.lineHeight || 'inherit', ";padding:0}\n\n.jpyTq_bGBk.jpyTq_bwkW{margin-bottom:").concat(theme.spacingXXXSmall || 'inherit', ";margin-top:").concat(theme.spacingXXXSmall || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_fBtB{margin-bottom:").concat(theme.spacingXXSmall || 'inherit', ";margin-top:").concat(theme.spacingXXSmall || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_bFmZ{margin-bottom:").concat(theme.spacingXSmall || 'inherit', ";margin-top:").concat(theme.spacingXSmall || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_bCcs{margin-bottom:").concat(theme.spacingSmall || 'inherit', ";margin-top:").concat(theme.spacingSmall || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_cYsY{margin-bottom:").concat(theme.spacingMedium || 'inherit', ";margin-top:").concat(theme.spacingMedium || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_cpQM{margin-bottom:").concat(theme.spacingLarge || 'inherit', ";margin-top:").concat(theme.spacingLarge || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_baAf{margin-bottom:").concat(theme.spacingXLarge || 'inherit', ";margin-top:").concat(theme.spacingXLarge || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_bNHb{margin-bottom:").concat(theme.spacingXXLarge || 'inherit', ";margin-top:").concat(theme.spacingXXLarge || 'inherit', "}\n\n.jpyTq_bGBk:first-of-type{margin-top:0}\n\n.jpyTq_bGBk:last-of-type{margin-bottom:0}\n\n.jpyTq_bGBk.jpyTq_bHSn,.jpyTq_bGBk.jpyTq_dtEo{list-style-position:inside}\n\n.jpyTq_bGBk.jpyTq_dtEo:not(:first-of-type){border-top:").concat(theme.delimiterDashedBorder || 'inherit', "}\n\n.jpyTq_bGBk.jpyTq_iLHf{list-style-position:inside}\n\n.jpyTq_bGBk.jpyTq_iLHf:not(:first-of-type){border-top:").concat(theme.delimiterSolidBorder || 'inherit', "}\n\n.jpyTq_eXrk{display:inline-block}\n\n.jpyTq_eXrk.jpyTq_cfzP .jpyTq_eLRq{-webkit-margin-end:").concat(theme.noneSpacing || 'inherit', ";-webkit-margin-start:").concat(theme.noneSpacing || 'inherit', ";margin-inline-end:").concat(theme.noneSpacing || 'inherit', ";margin-inline-start:").concat(theme.noneSpacing || 'inherit', "}\n\n[dir=ltr] .jpyTq_eXrk.jpyTq_cfzP .jpyTq_eLRq{margin-left:").concat(theme.noneSpacing || 'inherit', ";margin-right:").concat(theme.noneSpacing || 'inherit', "}\n\n[dir=rtl] .jpyTq_eXrk.jpyTq_cfzP .jpyTq_eLRq{margin-left:").concat(theme.noneSpacing || 'inherit', ";margin-right:").concat(theme.noneSpacing || 'inherit', "}\n\n.jpyTq_eXrk.jpyTq_dnHs .jpyTq_eLRq{-webkit-margin-end:").concat(theme.pipeSpacing || 'inherit', ";-webkit-margin-start:").concat(theme.pipeSpacing || 'inherit', ";margin-inline-end:").concat(theme.pipeSpacing || 'inherit', ";margin-inline-start:").concat(theme.pipeSpacing || 'inherit', "}\n\n[dir=ltr] .jpyTq_eXrk.jpyTq_dnHs .jpyTq_eLRq{margin-left:").concat(theme.pipeSpacing || 'inherit', ";margin-right:").concat(theme.pipeSpacing || 'inherit', "}\n\n[dir=rtl] .jpyTq_eXrk.jpyTq_dnHs .jpyTq_eLRq{margin-left:").concat(theme.pipeSpacing || 'inherit', ";margin-right:").concat(theme.pipeSpacing || 'inherit', "}\n\n.jpyTq_eXrk.jpyTq_dnHs .jpyTq_eLRq:after{content:\"|\"}\n\n.jpyTq_eXrk.jpyTq_fKZL .jpyTq_eLRq{-webkit-margin-end:").concat(theme.slashSpacing || 'inherit', ";-webkit-margin-start:").concat(theme.slashSpacing || 'inherit', ";margin-inline-end:").concat(theme.slashSpacing || 'inherit', ";margin-inline-start:").concat(theme.slashSpacing || 'inherit', "}\n\n[dir=ltr] .jpyTq_eXrk.jpyTq_fKZL .jpyTq_eLRq{margin-left:").concat(theme.slashSpacing || 'inherit', ";margin-right:").concat(theme.slashSpacing || 'inherit', "}\n\n[dir=rtl] .jpyTq_eXrk.jpyTq_fKZL .jpyTq_eLRq{margin-left:").concat(theme.slashSpacing || 'inherit', ";margin-right:").concat(theme.slashSpacing || 'inherit', "}\n\n.jpyTq_eXrk.jpyTq_fKZL .jpyTq_eLRq:after{content:\"/\"}\n\n.jpyTq_eXrk.jpyTq_cwfJ .jpyTq_eLRq{-webkit-margin-end:").concat(theme.arrowSpacing || 'inherit', ";-webkit-margin-start:").concat(theme.arrowSpacing || 'inherit', ";margin-inline-end:").concat(theme.arrowSpacing || 'inherit', ";margin-inline-start:").concat(theme.arrowSpacing || 'inherit', "}\n\n[dir=ltr] .jpyTq_eXrk.jpyTq_cwfJ .jpyTq_eLRq{margin-left:").concat(theme.arrowSpacing || 'inherit', ";margin-right:").concat(theme.arrowSpacing || 'inherit', "}\n\n[dir=rtl] .jpyTq_eXrk.jpyTq_cwfJ .jpyTq_eLRq{margin-left:").concat(theme.arrowSpacing || 'inherit', ";margin-right:").concat(theme.arrowSpacing || 'inherit', "}\n\n.jpyTq_eXrk.jpyTq_cwfJ .jpyTq_eLRq:after{content:\">\"}\n\n.jpyTq_doqw{font-size:").concat(theme.fontSizeSmall || 'inherit', "}\n\n.jpyTq_ycrn{font-size:").concat(theme.fontSizeMedium || 'inherit', "}\n\n.jpyTq_cMDj{font-size:").concat(theme.fontSizeLarge || 'inherit', "}");
  },
  'root': 'jpyTq_bGBk',
  'spacing--xxx-small': 'jpyTq_bwkW',
  'spacing--xx-small': 'jpyTq_fBtB',
  'spacing--x-small': 'jpyTq_bFmZ',
  'spacing--small': 'jpyTq_bCcs',
  'spacing--medium': 'jpyTq_cYsY',
  'spacing--large': 'jpyTq_cpQM',
  'spacing--x-large': 'jpyTq_baAf',
  'spacing--xx-large': 'jpyTq_bNHb',
  'delimeter--none': 'jpyTq_bHSn',
  'delimiter--dashed': 'jpyTq_dtEo',
  'delimiter--solid': 'jpyTq_iLHf',
  'inline': 'jpyTq_eXrk',
  'delimiter--none': 'jpyTq_cfzP',
  'delimiter': 'jpyTq_eLRq',
  'delimiter--pipe': 'jpyTq_dnHs',
  'delimiter--slash': 'jpyTq_fKZL',
  'delimiter--arrow': 'jpyTq_cwfJ',
  'small': 'jpyTq_doqw',
  'medium': 'jpyTq_ycrn',
  'large': 'jpyTq_cMDj'
};
import theme from "./theme.js";
/**
---
parent: List
id: List.Item
---
**/

var ListItem = (_dec = testable(), _dec2 = themeable(theme, styles), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ListItem, _Component);

  var _super = _createSuper(ListItem);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _classes;

      var _this$props = this.props,
          delimiter = _this$props.delimiter,
          spacing = _this$props.spacing,
          size = _this$props.size,
          margin = _this$props.margin,
          padding = _this$props.padding,
          elementRef = _this$props.elementRef,
          children = _this$props.children,
          variant = _this$props.variant,
          rest = _objectWithoutProperties(_this$props, ["delimiter", "spacing", "size", "margin", "padding", "elementRef", "children", "variant"]);

      var withDelimiter = delimiter !== 'none';
      var withSpacing = spacing !== 'none';

      /*#__PURE__*/

      /*#__PURE__*/
      _error(!(withDelimiter && withSpacing), "[List] `itemSpacing` has no effect inside Lists with the `delimiter` prop set to anything other than `none`.");

      var classes = (_classes = {}, _defineProperty(_classes, styles.root, true), _defineProperty(_classes, styles[size], size), _defineProperty(_classes, styles["delimiter--".concat(delimiter)], delimiter !== 'none' ? true : null), _defineProperty(_classes, styles["spacing--".concat(spacing)], withSpacing && !withDelimiter), _classes);
      return /*#__PURE__*/React.createElement(View, Object.assign({}, passthroughProps(rest), {
        className: classnames(classes),
        as: "li",
        margin: margin,
        padding: padding,
        maxWidth: "100%",
        elementRef: elementRef
      }), children, variant === 'inline' && /*#__PURE__*/React.createElement("span", {
        className: styles.delimiter,
        "aria-hidden": "true"
      }));
    }
  }]);

  ListItem.displayName = "ListItem";
  return ListItem;
}(Component), _class2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * Inherits delimiter from the parent List component.
   */
  delimiter: deprecated.deprecatePropValues(PropTypes.oneOf(['none', 'dashed', 'solid', 'pipe', 'slash', 'arrow']), ['pipe', 'slash', 'arrow'], function (_ref) {
    var propValue = _ref.propValue;
    return "with 'delimiter' set to ".concat(propValue, " will only be available when using [InlineList.Item] as of version 8.0.0.");
  }),
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
   * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
   * familiar CSS-like shorthand. For example: `margin="small auto large"`.
   */
  margin: ThemeablePropTypes.spacing,

  /**
   * Valid values are `0`, `none`, `xxx-small`, `xx-small`, `x-small`,
   * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
   * familiar CSS-like shorthand. For example: `padding="small x-large large"`.
   */
  padding: ThemeablePropTypes.spacing,

  /**
   * Inherits itemSpacing from the parent List component
   */
  spacing: PropTypes.oneOf(['none', 'xxx-small', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  elementRef: PropTypes.func,

  /**
   * __deprecated:__ inline will be InlineList
   */
  variant: PropTypes.oneOf(['default', 'unstyled', 'inline'])
}, _class2.defaultProps = {
  padding: 'none',
  margin: void 0,
  spacing: 'none',
  delimiter: 'none',
  size: 'medium',
  elementRef: function elementRef(el) {},
  variant: void 0
}, _temp)) || _class) || _class);
export default ListItem;
export { ListItem };